import Laydash from "components/Layout/Laydash";
import React, { useCallback, useEffect, useRef, useState, useMemo } from "react";
import { Container, Img, DatePickerWrapper } from "./styles";
import WalletBox from "./WalletBox";
import { FormHandles } from '@unform/core';
import { Form as UForm } from '@unform/web';
import { Select, WrapperLabel } from '../../../components/Forms';
import DatePicker, { registerLocale } from 'react-datepicker';
import { Table } from "../../../components/Table";
import { useHttp } from "hooks/http";
import { useAuth } from "hooks/auth";
import { format } from 'date-fns';
import logoImg from '../../../assets/rj-todos.png';
import pt from 'date-fns/locale/pt-BR'; // eslint-disable-line
import Grid from "@material-ui/core/Grid";

registerLocale('pt-BR', pt);

const links = [
    { path: '/dashboard', title: "HOME", key: 1 },
    { path: '#', title: "ATUALIZAR", key: 3, isReset: true },
];

const Dashboard: React.FC = () => {
    const formRef = useRef<FormHandles>(null);
    const [filters, setFilters] = useState<any>({});
    const [social, setSocial] = useState([]);
    const [total, setTotal] = useState(0);
    const [totalServicos, setTotalServicos] = useState(0);
    const [totalPresente, setTotalPresente] = useState(0);
    const [bairros, setBairros] = useState<any[]>([]);
    const [municipios, setMunicipios] = useState<any[]>([]);
    const [regioes, setRegioes] = useState<any[]>([]);
    const [partners, setPartners] = useState<Array<{ value: string; label: string }>>([]);
    const [services, setServices] = useState<Array<{ value: string; label: string }>>([]);
    const { user } = useAuth();
    const { httpGet } = useHttp();

    const [prime] = useState('');
    const [filterStartDate, setFilterStartDate] = useState('');
    const [filterEndDate, setFilterEndDate] = useState('');
    const [dateRange, setDateRange] = useState(['', '']);
    const [startDate, endDate]: any = dateRange;
    const rangeDate = !startDate
        ? (`${prime} - ${format(new Date(), 'dd MMM yyyy')}`)
        : (`${format(new Date(startDate), 'dd MMM yyyy')} - ${format(new Date(endDate), 'dd MMM yyyy')}`);
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        async function getSocialAction(): Promise<void> {
           
            const { status, data } = await httpGet(`social-action/dashlist`, {
                params: {
                    filterStartDate,
                    filterEndDate,
                    filter:filters
                },
            });

            if (status === 200) {
                setTotal(data.data?.length)
                setSocial(data.data)

                // Somar total de serviços (quantity em details)
                const somaServicos = data.data?.reduce((acc: number, item: any) => {
                    const quantityDetails = item.details?.reduce((sum: number, detail: any) => {
                        return sum + (Number(detail.quantity) || 0);
                    }, 0) || 0;
                    return acc + quantityDetails;
                }, 0) || 0;
                setTotalServicos(somaServicos);

                // Somar total de público presente (attendance_count)
                const somaPresente = data.data?.reduce((acc: number, item: any) => {
                    return acc + (Number(item.attendance_count) || 0);
                }, 0) || 0;
                setTotalPresente(somaPresente);

                // Extrair bairros únicos e formatar para o select
                const bairrosUnicos = Array.from(new Set(data.data?.map((item: any) => item.bairro).filter(Boolean)))
                    .map((bairro: any) => ({
                        label: bairro,
                        value: bairro
                    }));
                setBairros(bairrosUnicos);

                const municipiosUnicos = Array.from(new Set(data.data?.map((item: any) => item.municipio).filter(Boolean)))
                    .map((municipio: any) => ({
                        label: municipio,
                        value: municipio
                    }));
                setMunicipios(municipiosUnicos);

                const regioesUnicos = Array.from(new Set(data.data?.map((item: any) => item.regiao).filter(Boolean)))
                    .map((regiao: any) => ({
                        label: regiao,
                        value: regiao
                    }));
                setRegioes(regioesUnicos);
            }
        }

        getSocialAction();

    }, [filters, filterStartDate, filterEndDate , user]); // eslint-disable-line

    function handleSubmit() {

    }

     useEffect(() => {
        async function loadPartners(): Promise<void> {
          const { status, data } = await httpGet('social-action/partners/all');
          if (status === 200) {
            const stations = data
              ?.map((station: any) => ({
                value: station.id,
                label: `${station.partner_name}`,
              }));
    
            setPartners(stations);
          }
        }
    
        loadPartners();
      }, [httpGet]);


       useEffect(() => {
        async function loadServices(): Promise<void> {
          const { status, data } = await httpGet('social-action/services/all');
          if (status === 200) {
            const stations = data
              ?.map((station: any) => ({
                value: station.id,
                label: `${station.service_name}`,
              }));
    
            setServices(stations);
          }
        }
    
        loadServices();
      }, [httpGet]);

    const columns = useMemo(
        () => [
             {
                Header: 'Data',
                accessor: 'data_acao',
            },
            {
                Header: 'Bairro',
                accessor: 'bairro',
            },
            {
                Header: 'Município',
                accessor: 'municipio',
            },
            {
                Header: 'Região',
                accessor: 'regiao',
            },
            {
                Header: 'Total de Serviços',
                accessor: 'total_quantity',
            },
            {
                Header: 'Público Presente',
                accessor: 'attendance_count',
            },
        ],
        []
    )

    const handleSearch = useCallback((filter: any, name: string) => {
        setFilters((prevFilters: any) => ({
            ...prevFilters,
            [name]: filter?.value || ''
        }));
    }, []);

    const handleDate = useCallback((data: any) => {
        let date = new Date(data[0]),
        mnth = ("0" + (date.getMonth() + 1)).slice(-2),
        day = ("0" + date.getDate()).slice(-2);
        const dd = [date.getFullYear(), mnth, day].join("-")

        let date1 = new Date(data[1]),
        mnth1 = ("0" + (date1.getMonth() + 1)).slice(-2),
        day1 = ("0" + date1.getDate()).slice(-2);
        const dd1 = [date1.getFullYear(), mnth1, day1].join("-")

        setFilterStartDate(dd);
        setFilterEndDate(dd1);
    }, []);

    const handleReset = useCallback(() => {
        setFilters({});
        setFilterStartDate('');
        setFilterEndDate('');
        setDateRange(['', '']);
        formRef.current?.reset();
    }, []);

    return (
        <Laydash links={links} onReset={handleReset}> 
            <UForm ref={formRef} onSubmit={handleSubmit}>
                <Grid
                    container
                    direction="row"
                    justify="center"
                    alignItems="center"
                    style={{ marginTop: 10}}
                > 
                 <Grid item xs={12} sm={4} md={3}>
                    <WrapperLabel label="Data" xs={12} md={12}>
                        <DatePickerWrapper>
                            <DatePicker
                                name="date_poll"
                                placeholderText={rangeDate}
                                onInputClick={() => setIsOpen(true)}
                                onClickOutside={() => setIsOpen(false)}
                                open={isOpen}
                                selectsRange
                                startDate={startDate}
                                endDate={endDate}
                                onChange={(update: any) => {
                                    setDateRange(update);
                                    if (update[1]) {
                                        setIsOpen(false);
                                    }
                                    handleDate(update)
                                    }}
                                minDate={new Date(prime)}
                                maxDate={new Date()}
                                dateFormat="dd/MM/yyyy"
                                locale="pt-BR"
                            />
                        </DatePickerWrapper>
                    </WrapperLabel>
                    </Grid>
                </Grid>
                <Grid
                    container
                    spacing={2}
                    direction="row"
                    justify="center"
                    alignItems="center"
                    style={{ marginTop: 10}}
                >    
                    <Grid item xs={12} sm={4} md={3}>
                        <WrapperLabel label="Bairro da Ação" xs={12} md={12}>
                            <Select
                                name="bairro"
                                options={bairros}
                                onChange={(value) => handleSearch(value, 'bairro')}
                            />
                        </WrapperLabel>
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                        <WrapperLabel label="Município da Ação" xs={12} md={12}>
                            <Select
                                name="municipio"
                                options={municipios}
                                onChange={(value) => handleSearch(value, 'municipio')}
                            />
                        </WrapperLabel>
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                        <WrapperLabel label="Região da Ação" xs={12} md={12}>
                            <Select
                                name="regiao"
                                options={regioes}
                                onChange={(value) => handleSearch(value, 'regiao')}
                            />
                        </WrapperLabel>
                    </Grid>
                </Grid>
                <Grid
                    container
                    spacing={2}
                    direction="row"
                    justify="center"
                    alignItems="center"
                    style={{ marginTop: 10}}
                >    
                    <Grid item xs={12} sm={4} md={3}>
                        <WrapperLabel label="Parceiro da Ação" xs={12} md={12}>
                            <Select
                                name="partner"
                                options={partners}
                                onChange={(value) => handleSearch(value, 'partner')}
                            />
                        </WrapperLabel>
                    </Grid>
                  
                    <Grid item xs={12} sm={4} md={3}>
                        <WrapperLabel label="Serviço da Ação" xs={12} md={12}>
                            <Select
                                name="service"
                                options={services}
                                onChange={(value) => handleSearch(value, 'service')}
                            />
                        </WrapperLabel>
                    </Grid>
                </Grid>
            </UForm>
       
            <Container>
                <Img src={logoImg} />
                <WalletBox
                    title="Total Ações"
                    amount={total}
                    color="#2E7D32"
                />
                <WalletBox
                    title="Total Serviços"
                    amount={totalServicos}
                    color="#F57C00"
                />
                <WalletBox
                    title="Púb. Presente"
                    amount={totalPresente}
                    color="#7B1FA2"
                />
                <Img src={logoImg} />
                
            </Container>
            <Table columns={columns} data={social} />
        </Laydash>
    )
}

export default Dashboard;